import React from 'react'

const Blogs = () => {
  return (
    <div className="jp_blog_cate_main_wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 margin_top visible-lg visible-md">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_rightside_job_categories_wrapper jp_blog_right_box_search">
                  <div className="jp_rightside_job_categories_heading">
                    <h4>Ara</h4>
                  </div>
                  <div className="jp_blog_right_search_wrapper">
                    <input type="text" placeholder="Ara" />
                    <button type="submit">
                      <i className="fa fa-search" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_rightside_job_categories_wrapper jp_blog_right_box">
                  <div className="jp_rightside_job_categories_heading">
                    <h4>Kategori</h4>
                  </div>
                  <div className="jp_rightside_job_categories_content">
                    <ul>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Araştırma Geliştirme (AR-GE)
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Geri Ödeme/Pazara Erişim
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Klinik Destek/Aplikasyon
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Kalite/Belgelendirme/Mevzuat
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Lojistik ve Tedarik Zinciri
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Pazarlama/Ürün Yönetimi
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Satış
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Teknik Servis
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Teknoloji Yönetimi
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Test/Kalibrasyon/Muayene
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Üretim
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Akademik
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                        Diğer
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
            <div className="row" style={{ padding: 20 }}>
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_blog_cate_left_main_wrapper">
                  <div className="jp_first_blog_post_main_wrapper">
                    <div className="jp_first_blog_post_img">
                      <img
                        src="https://media.licdn.com/dms/image/v2/D4D12AQHQrjlxtjWglg/article-cover_image-shrink_720_1280/B4DZWuPYkiG4AI-/0/1742385024589?e=1748476800&v=beta&t=T5ciUVj9lAbV2fCUX2qKWL3L8uH-4Ge3XvJC0O1-wVg"
                        className="img-responsive"
                        alt="blog_img"
                      />
                    </div>
                    <div className="jp_first_blog_post_cont_wrapper">
                      <ul>
                        <li>
                          <a href="/">
                            <i className="fa fa-calendar" /> &nbsp;&nbsp;21.05.2024
                          </a>
                        </li>
                        <li>
                          <a href="/">
                            <i className="fa fa-clone" /> &nbsp;&nbsp; NANOMALZEME
                          </a>
                        </li>
                      </ul>
                      <h3>
                        <a href="https://www.linkedin.com/pulse/biyomed-b%C3%BClten-say%C4%B1-28-21-mart-2025-derne%C4%9Fi-wyshf/?trackingId=g93l9Lb%2FS8aniEpCo5pmSA%3D%3D">NANOMALZEMELERİN BİYOMEDİKAL ALANDA KULLANIMI</a>
                      </h3>
                      <p>
                        İnsan sağlığını ve konforunu baz alarak çalışmalar yapan biyomedikal mühendisleri, malzeme bilimiyle yakından ilgilenmektedir. Biyouyumluluk başta olmak üzere, optik, manyetik ve elektriksel özellikler gösteren malzemeler, biyomedikal mühendisleri için aranan önemli malzeme özelliklerindendir. Nanomalzemeler, bu özelliklere uyumlu olmaları nedeniyle biyomedikal alanda sıkça tercih edilen ve birçok farklı uygulamada kullanılan malzemelerdendir. Boyutları 1-100 nm arasında değişen nanomalzemeler, ana materyalin yapısına göre farklı özellikler sergileyebilir. Nano ölçekte optik, manyetik ve elektriksel özellikler gösterebilen bu malzemeler, biyomedikal kullanımlar açısından büyük bir avantaj sağlamaktadır. Nanomalzemelerin sahip oldukları özellikler göz önünde bulundurularak, hangi biyomedikal alanlarda kullanıldıklarını daha detaylı bir şekilde inceleyelim.
                      </p>
                    </div>
                    <div className="jp_first_blog_bottom_cont_wrapper">
                      <div className="jp_blog_bottom_left_cont">
                        <ul>
                          <li>
                            <img
                              src="https://biyomed.net/kariyer_images/biyomed1.png"
                              alt="small_img"
                              className="img-circle"
                            />
                            &nbsp;&nbsp; Elif Sezgin
                          </li>
                        </ul>
                      </div>
                      <div className="jp_blog_bottom_right_cont">
                        <p className="hidden-xs">
                          <a href="#" className="hidden-xs">
                            <i className="fa fa-comments" />
                          </a>
                        </p>
                        <ul>
                          <li>Linkler :</li>
                          <li>
                            <a href="https://www.linkedin.com/pulse/biyomed-b%C3%BClten-say%C4%B1-28-21-mart-2025-derne%C4%9Fi-wyshf/?trackingId=g93l9Lb%2FS8aniEpCo5pmSA%3D%3D">
                              <i className="fa fa-linkedin" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 margin_top visible-sm visible-xs">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_rightside_job_categories_wrapper jp_blog_right_box">
                  <div className="jp_rightside_job_categories_heading">
                    <h4>Jobs by Category</h4>
                  </div>
                  <div className="jp_rightside_job_categories_content">
                    <ul>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                          Graphic Designer <span>(214)</span>
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                          Engineering Jobs <span>(514)</span>
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                          Mainframe Jobs <span>(554)</span>
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                          Legal Jobs <span>(457)</span>
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                          IT Jobs <span>(1254)</span>
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                          R&amp;D Jobs <span>(554)</span>
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                          Government Jobs <span>(350)</span>
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-caret-right" />{" "}
                        <a href="/">
                          PSU Jobs <span>(221)</span>
                        </a>
                      </li>
                      <li>
                        <i className="fa fa-plus-circle" />{" "}
                        <a href="/">View All Categories</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default Blogs